export default __webpack_public_path__ + "img/abdfbe4620827db66196c2eff82690c2.svg";